import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import CustomPagination from "../../components/CustomPagination";
import FilterMenu from "../../components/filterMenu";
import AddTagsModal from "../../Modals/addTagModal";
import TagTable from "./tagTable";
import { isValidInput } from "../../utils/validations";
import { useLazyGetTagsQuery } from "../../service/group&tags";
import { showError } from "../../constants/toasts";
import Loader from "../../constants/Loader";

const ManageTags = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [getTags] = useLazyGetTagsQuery();
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [tagsData, setTagsData] = useState([]);
  const [selectedTag, setSelectedTag] = useState<any>();
  const [selectedTagId, setSelectedTagId] = useState("");
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);

  const getTagsApi = async () => {
    setLoading(true);
    try {
      const response = await getTags({
        page,
        search: debouncedSearchTerm.trim(),
        groupId: id,
      }).unwrap();
      setLoading(false);
      setHasFetched(true);
      if (response.status === 200) {
        setTagsData(response?.data?.items || []);
        setCount(response?.data?.totalCount);
      } else {
        setTagsData([]);
      }
    } catch (error: any) {
      setHasFetched(true);
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getTagsApi();
  }, [page, debouncedSearchTerm]);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title d_flex">
          <h1>Manage Tags</h1>
          <div className="right_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
            <Button
              className="btn btn_primary"
              onClick={() => {
                setOpen(true);
                setSelectedTagId("");
                setSelectedTag(null);
              }}
            >
              + Add Tags
            </Button>
            <FilterMenu
              startDate={null}
              endDate={null}
              setStartDate={() => { }}
              setEndDate={() => { }}
            />

            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-groups")}
            >
              Back
            </Button>
          </div>
        </div>

        <div className="cards table_cards v2">
          <TagTable
            data={tagsData}
            setSelectedTag={setSelectedTag}
            selectedTag={selectedTag}
            selectedTagId={selectedTagId}
            setSelectedTagId={setSelectedTagId}
            getTagsApi={getTagsApi}
            groupId={id}
          />
        </div>
        {tagsData?.length ? (
          <CustomPagination
            currentPage={page - 1}
            totalPages={Math.ceil(count / 10)}
            count={count}
            pageSize={10}
            onPageChange={(page) => setPage(page + 1)}
          />
        ) : null}
      </MainContainer>
      <AddTagsModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        getTagsApi={getTagsApi}
        selectedTag={selectedTag}
        selectedTagId={selectedTagId}
        groupId={id}
      />
    </>
  );
};

export default ManageTags;
